export default {
  columns: {
    strategy: 'Strategie',
    source: 'Bron',
    async: 'Async',
    content: 'Inhoud',
    edit: 'Bewerken',
    delete: 'Verwijderen',
  },
  buttons: {
    add_script: 'Script toevoegen',
  },
};
